// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './DiamondColor.style';

export class DiamondColor extends PureComponent {
    static propTypes = {
        product: this.propTypes,
        diamond_color: this.propTypes,
        girdle_max: this.propTypes
    };

    state = {
        activeColor: {},
        activeIntenseColor: {},
        activeColorDiamond: {}
    }

    color = [
        {
            label: "D",
            description: "D: Completely colorless. The rarest and most premium grade, perfect for those seeking perfection.",
            img: "/media/diamond-info-images/color-d.png"
        },
        {
            label: "E",
            description: "E: Colorless. Minimal color, detectable only by experts under 10x magnification. A top-tier choice for luxury.a",
            img: "/media/diamond-info-images/color-e.png"
        },
        {
            label: "F",
            description: "F: Colorless. Slight color saturation visible only under 10x magnification. Excellent for high-end jewelry.",
            img: "/media/diamond-info-images/color-f.png"
        },
        {
            label: "G",
            description: "G: Near colorless. A faint yellow tint in bright light, but appears white to the naked eye. Great value.",
            img: "/media/diamond-info-images/color-g.png"
        },
        {
            label: "H",
            description: "H: Near colorless. Mostly colorless, with a faint yellow hue in certain lighting. Ideal for most settings.",
            img: "/media/diamond-info-images/color-h.png"
        },
        {
            label: "I",
            description: "I: Near colorless. Slight warmth visible face-up, but still a budget-friendly option.",
            img: "/media/diamond-info-images/color-i.png"
        },
        {
            label: "J",
            description: "J: Near colorless. A faint yellow hue noticeable in bright light. A practical choice for everyday wear.",
            img: "/media/diamond-info-images/color-j.png"
        },
        {
            label: "K",
            description: "K: Faint yellow tint. Visible warmth, offering a vintage look at an affordable price.",
            img: "/media/diamond-info-images/color-k.png"
        },
        {
            label: "L",
            description: "L: Faint yellow tint. Noticeable color, ideal for those seeking a unique, warm tone.",
            img: "/media/diamond-info-images/color-l.png"
        }
    ];

    intenseColor = [
        {
            label: "Fancy Light",
            description: "Soft, subtleswswsw color. A delicate and elegant choice for those who prefer a hint of color.",
            b: "/media/diamond-info-images/fancylight-b.png",
            pk: "/media/diamond-info-images/fancylight-pk.png",
            r: "/media/diamond-info-images/fancylight-r.png",
            gr: "/media/diamond-info-images/fancylight-gr.png",
            o: "/media/diamond-info-images/fancylight-o.png",
            y: "/media/diamond-info-images/fancylight-y.png",
        },
        {
            label: "Fancy",
            description: "Noticeable color. A vibrant and balanced option, perfect for distinctive jewelry pieces.",
            b: "/media/diamond-info-images/fancy-b.png",
            pk: "/media/diamond-info-images/fancy-pk.png",
            r: "/media/diamond-info-images/fancy-r.png",
            gr: "/media/diamond-info-images/fancy-gr.png",
            o: "/media/diamond-info-images/fancy-o.png",
            y: "/media/diamond-info-images/fancy-y.png",
        },
        {
            label: "Fancy Intence",
            description: "Rich, bold color. Highly saturated and eye-catching, ideal for statement-making designs.",
            b: "/media/diamond-info-images/fancyintence-b.png",
            pk: "/media/diamond-info-images/fancyintence-pk.png",
            r: "/media/diamond-info-images/fancyintence-r.png",
            gr: "/media/diamond-info-images/fancyintence-gr.png",
            o: "/media/diamond-info-images/fancyintence-o.png",
            y: "/media/diamond-info-images/fancyintence-y.png",
        },
        {
            label: "Fancy Vivid",
            description: "Extremely vivid and intense color. Exceptionally rare and the most sought-after grade for its striking brilliance.",
            b: "/media/diamond-info-images/fancyvivid-b.png",
            pk: "/media/diamond-info-images/fancyvivid-pk.png",
            r: "/media/diamond-info-images/fancyvivid-r.png",
            gr: "/media/diamond-info-images/fancyvivid-gr.png",
            o: "/media/diamond-info-images/fancyvivid-o.png",
            y: "/media/diamond-info-images/fancyvivid-y.png",
        },
        {
            label: "Fancy Deep",
            description: "Deep, luxurious color with a darker tone. Exudes sophistication and depth, offering a unique allure.",
            b: "/media/diamond-info-images/fancydeep-b.png",
            pk: "/media/diamond-info-images/fancydeep-pk.png",
            r: "/media/diamond-info-images/fancydeep-r.png",
            gr: "/media/diamond-info-images/fancydeep-gr.png",
            o: "/media/diamond-info-images/fancydeep-o.png",
            y: "/media/diamond-info-images/fancydeep-y.png",
        },
        {
            label: "Fancy Dark",
            description: "Dark, dramatic color. A bold and unconventional choice for those who love standout styles.",
            b: "/media/diamond-info-images/fancydark-b.png",
            pk: "/media/diamond-info-images/fancydark-pk.png",
            r: "/media/diamond-info-images/fancydark-r.png",
            gr: "/media/diamond-info-images/fancydark-gr.png",
            o: "/media/diamond-info-images/fancydark-o.png",
            y: "/media/diamond-info-images/fancydark-y.png",
        },

    ]

    componentDidMount() {
        const { diamond_color, girdle_max } = this.props;

        const color = this.color?.find((value) => (
            value?.label?.toLowerCase() === diamond_color?.toLowerCase()
        ));

        const colorIntense = this.intenseColor?.find((value) => (
            value?.label?.toLowerCase() === girdle_max?.toLowerCase()
        ));

        this.setState({
            activeColor: color ? color : this.color[0],
            activeIntenseColor: colorIntense ? colorIntense : this.intenseColor[0]
        });
    }

    changeDiamondInfo = (value) => {
        this.setState({
            activeColor: value
        });
    }

    changeDiamondIntenseInfo = (value) => {
        this.setState({
            activeIntenseColor: value
        });
    }

    renderColoredDaimond() {
        const { activeIntenseColor } = this.state;
        const { diamond_color, girdle_max } = this.props;

        return (
            <div className='DiamondDetails-ContentSection'>
                <img src={activeIntenseColor[diamond_color?.toLowerCase()]} />

                <div className='DiamondDetails-ListOf DiamondDetails-ListOf_IsColor'>
                    {
                        this.intenseColor?.map((value, index) => (
                            <div
                                className={'DiamondDetails-ListOf_item' + (value?.label?.toLowerCase() === activeIntenseColor?.label?.toLowerCase() ? " DiamondDetails-ListOf_item_active" : "")}
                                key={index}
                                onClick={() => this.changeDiamondIntenseInfo(value)}
                            >
                                <span>{value?.label}</span>
                            </div>
                        ))
                    }
                </div>

                <div className='DiamondDetails-ListOfContent'>
                    <p>{activeIntenseColor?.description}</p>
                </div>
            </div>
        )
    }

    render() {
        const {
            diamond_color
        } = this.props;

        const { activeColor } = this.state;

        const color_diamonds = ["y", "o", "pk", "b", "gr", "r"];

        if (color_diamonds?.includes(diamond_color?.toLowerCase())) {
            return this.renderColoredDaimond();
        }

        return (
            <div className='DiamondDetails-ContentSection'>
                <img src={activeColor?.img} />

                <div className='DiamondDetails-ListOf'>
                    {
                        this.color?.map((value, index) => (
                            <div className={'DiamondDetails-ListOf_item' + (value?.label?.toLowerCase() === activeColor?.label?.toLowerCase() ? " DiamondDetails-ListOf_item_active" : "")}
                                key={index}
                                onClick={() => this.changeDiamondInfo(value)}
                            >
                                <span>{value?.label}</span>
                            </div>
                        ))
                    }


                </div>

                <div className='DiamondDetails-ListOfContent'>
                    <p>{activeColor?.description}</p>
                </div>
            </div>
        );
    }
}

export default DiamondColor;
